import { Box, useTheme } from "@mui/material"
import { useTranslation } from "providers/i18n"
import { Head } from "components/Head"
import { MotionDiv } from "components/motions"
import { useDepartmentStore } from "extensions/em-department-store/hooks/useDepartmentStore"
import { EmptyData } from "components/EmptyData"
import { ShopIcon } from "components/icons"
import { useMemo } from "react"
import { getIcon } from "utils/icon"
import { ImageCard } from "components/ImageCard"
import { Link } from "react-router-dom"
import { getFeatureDetail } from "utils/feature"

export const EMDepartmentStoreMobilePage = () => {
  const { t } = useTranslation()
  const { departmentStoreCategories = [] } = useDepartmentStore()
  const theme = useTheme()

  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.department) || <ShopIcon />,
    [theme]
  )

  const styleOverrides =
    theme.components[`EmDepartmentStorePage`]?.styleOverrides || {}
  const { emptyDataContainer, gridContainer, departmentImageCard } =
    styleOverrides || {}

  return (
    <>
      <Head title={t("Department Store")} />
      <MotionDiv
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.15 }}
      >
        {departmentStoreCategories?.length === 0 ? (
          <Box sx={emptyDataContainer}>
            <EmptyData
              icon={emptyIcon}
              primary={t("Coming soon")}
              secondary={t("Stay tuned for the update")}
            />
          </Box>
        ) : (
          <Box sx={gridContainer}>
            {departmentStoreCategories.map((category) => {
              const { name } = getFeatureDetail(category) || {}
              return (
                <ImageCard
                  key={category?.id}
                  sx={departmentImageCard}
                  component={Link}
                  to={`${category?.id}/occupants`}
                  title={t(name)}
                  image={category?.properties?.icon_image}
                  avatar={null}
                />
              )
            })}
          </Box>
        )}
      </MotionDiv>
    </>
  )
}
